import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonUtilService } from 'app/services/commonUtil.service';
import { SpinnerService } from 'app/services/spinner.service';
import { RegisterService } from 'app/services/user/register.service';

@Component({
  selector: 'ms-personalDetail',
  templateUrl: './personalDetail.component.html',
  styleUrls: ['./personalDetail.component.css']
})
export class PersonalDetailComponent implements OnInit {

  submitted = false;
  error = false;
  success = false;
  registrationPersonalDetailForm: FormGroup;
  registerId: any;
  getPersonalData: any;
  checkIfUserAlreadyExist = false;
  confirmPasswordCheck = false;
  minDate: any;
  maxDate: any;

  constructor(
    private activatedRouter: ActivatedRoute,
    private formBuilder: FormBuilder,
    private registerService: RegisterService,
    private router: Router,
    private commonUtilService: CommonUtilService,
    public datepipe: DatePipe,
    private spinnerService: SpinnerService) { }

  ngOnInit(): void {
    this.spinnerService.start();

    var today = new Date();
    this.maxDate = this.datepipe.transform(today.setFullYear(today.getFullYear() - 20), 'yyyy-MM-dd');
    this.minDate = this.datepipe.transform(today.setFullYear(today.getFullYear() - 55), 'yyyy-MM-dd');

    this.registerId = this.activatedRouter.snapshot.paramMap.get("registerId");
    this.registrationPersonalDetailForm = this.registrationPersonalDetailFormBuilder(this.formBuilder);

    this.registerService.getUserPersonalDetail(this.registerId).subscribe(data => {
      if(data){
        this.getPersonalData = data;
        this.registrationPersonalDetailForm = this.registrationPersonalDetailFormBuilder(this.formBuilder);
      }
    });
    this.spinnerService.stop();

  }

  // convenience getter for easy access to form fields
  get f() { return this.registrationPersonalDetailForm.controls; }
  // convenience getter for easy access to form fields
  get val() { return this.registrationPersonalDetailForm.value; }

  // form builder service create form group instances
  registrationPersonalDetailFormBuilder = (formBuilder: FormBuilder) => {
    return formBuilder.group({
      firstName: [this.getPersonalData && this.getPersonalData.firstName ? this.getPersonalData.firstName : '', [Validators.required]],
      lastName: [this.getPersonalData && this.getPersonalData.lastName ? this.getPersonalData.lastName : '', [Validators.required]],
      fiscalCode: [this.getPersonalData && this.getPersonalData.fiscalCode && this.getPersonalData.fiscalCode.value ? this.getPersonalData.fiscalCode.value : '', [Validators.required, Validators.pattern('^[A-Za-z0-9]{16}$')]],
      dateOfBirth: [this.getPersonalData && this.getPersonalData.dateOfBirth ? this.datepipe.transform(this.getPersonalData.dateOfBirth, 'yyyy-MM-dd') : '', [Validators.required]],
      cityOfBirth: [this.getPersonalData && this.getPersonalData.cityOfBirth ? this.getPersonalData.cityOfBirth : '', [Validators.required]],
      countryOfBirth: [this.getPersonalData && this.getPersonalData.countryOfBirth ? this.getPersonalData.countryOfBirth : '', [Validators.required]],
      personalResidenceVia: [this.getPersonalData && this.getPersonalData.address && this.getPersonalData.address.street ? this.getPersonalData.address.street : '', [Validators.required]],
      personalResidenceNCivic: [this.getPersonalData && this.getPersonalData.address && this.getPersonalData.address.houseNumber ? this.getPersonalData.address.houseNumber : '', [Validators.required]],
      personalResidenceCity: [this.getPersonalData && this.getPersonalData.address && this.getPersonalData.address.city ? this.getPersonalData.address.city : '', [Validators.required]],
      personalResidenceProvince: [this.getPersonalData && this.getPersonalData.address && this.getPersonalData.address.district ? this.getPersonalData.address.district : '', [Validators.required]],
      personalResidenceCountry: [this.getPersonalData && this.getPersonalData.address && this.getPersonalData.address.country ? this.getPersonalData.address.country : '', [Validators.required]],
      telephoneNumberPrefix: [this.getPersonalData && this.getPersonalData.phoneNumber && this.getPersonalData.phoneNumber.countryCode ? this.getPersonalData.phoneNumber.countryCode : '', [Validators.pattern('^[+]?[0-9]{2,4}$')]],
      telephoneNumber: [this.getPersonalData && this.getPersonalData.phoneNumber && this.getPersonalData.phoneNumber.number ? this.getPersonalData.phoneNumber.number : '', [Validators.required, Validators.pattern('^[0-9]{10}$')]]
    });
  }

  onSubmit() {
    this.spinnerService.start();
    this.submitted = true;
    this.error = false;

    if (this.registrationPersonalDetailForm.invalid) {
      this.spinnerService.stop();
      return;
    }

    var personalDetail = {
      firstName: this.val.firstName,
      lastName: this.val.lastName,
      fiscalCode: {
        value: this.val.fiscalCode,
      },
      dateOfBirth: this.val.dateOfBirth,
      cityOfBirth: this.val.cityOfBirth,
      countryOfBirth: this.val.countryOfBirth,
      address: {
        street: this.val.personalResidenceVia,
        houseNumber: this.val.personalResidenceNCivic,
        city: this.val.personalResidenceCity,
        district: this.val.personalResidenceProvince,
        country: this.val.personalResidenceCountry
      },
      phoneNumber: {
        countryCode: this.val.telephoneNumberPrefix,
        number: this.val.telephoneNumber
      }
    };

    this.registerService.addUserPersonalDetail(this.registerId, personalDetail).subscribe(data => {
      /* console.log(data); */
      this.router.navigate(['/registrazione/' + this.registerId + '/companyDetail']);
    }, err => {
      this.error = true;
      this.spinnerService.stop();
      setTimeout(()=>{                           
        this.error = false;
      }, 2000);
    });
  }
}
